export default __webpack_public_path__ + "static/09_V1@2x-3c34112cbcbaba4772a392275ca864c4.png";